import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Textarea from 'react-textarea-autosize';
import {
  FormGroup,
  FormText,
  Label,
  Input,
  UncontrolledTooltip,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

class UploadFileCustomField extends PureComponent {
  getCustomFieldValue() {
    const {
      customField,
      file,
    } = this.props;

    if (file && file.custom_fields && file.custom_fields.length > 0) {
      const fileCustomField = file.custom_fields.find(cf => (cf.id === customField.id));
      if (fileCustomField) {
        return fileCustomField.value;
      }
    }

    return '';
  }

  render() {
    const {
      intl,
      customField,
      selectedFiles,
      handleCustomFieldChange,
      forceRequiredError,
      forceUrlError,
      title,
      copyLinks,
      setRef,
    } = this.props;

    const showCustomFieldRequiredError = forceRequiredError || !!selectedFiles.find(sf => {
      if (
        sf.errors &&
        sf.errors.customFields &&
        sf.errors.customFields.find(t => (t === customField.id))) {
        return true;
      }
      return false;
    });

    const showCustomFieldUrlsError = forceUrlError || !!selectedFiles.find(sf => {
      if (
        sf.errors &&
        sf.errors.customFieldsUrls &&
        sf.errors.customFieldsUrls.find(t => (t === customField.id))) {
        return true;
      }
      return false;
    });

    return (
      <FormGroup>
        <Label for={`customField${customField.id}`}>
          {title || customField.name}
          {customField.required && (
            <span
              className="required-asterisk"
              id={`custom-field-required-asterisk-${customField.id}`}
            >
              *
              <UncontrolledTooltip fade={false} placement="bottom" target={`custom-field-required-asterisk-${customField.id}`}>
                {intl.formatMessage({ defaultMessage: 'Required' })}
              </UncontrolledTooltip>
            </span>
          )}
        </Label>
        {(customField.type === 'text' || customField.type === 'url') && (
          <Input
            type="text"
            name={`cf-${customField.id}`}
            id={`customField${customField.id}`}
            defaultValue={this.getCustomFieldValue()}
            innerRef={(ref) => { setRef(customField.id, ref); }}
            onInput={(e) => {
              handleCustomFieldChange({
                ...customField,
                value: e.target.value,
              });
            }}
          />
        )}
        {customField.type === 'textarea' && (
          <Textarea
            className="form-control"
            name={`cf-${customField.id}`}
            id={`customField${customField.id}`}
            defaultValue={this.getCustomFieldValue()}
            ref={(ref) => { setRef(customField.id, ref); }}
            onInput={(e) => {
              handleCustomFieldChange({
                ...customField,
                value: e.target.value,
              });
            }}
          />
        )}
        {(copyLinks !== null && copyLinks('custom_field', customField.id)) && (
          <FormText color="muted">
            {intl.formatMessage({
              defaultMessage: 'Copy {fieldName} from: {copyLinks}',
            }, { fieldName: customField.name.toLowerCase(), copyLinks: copyLinks('custom_field', customField.id) })}
          </FormText>
        )}
        {showCustomFieldRequiredError && (
          <div className="invalid-feedback" style={{ display: 'block' }}>
            {intl.formatMessage({ defaultMessage: 'This field is required' })}
          </div>
        )}
        {(!showCustomFieldRequiredError && showCustomFieldUrlsError) && (
          <div className="invalid-feedback" style={{ display: 'block' }}>
            {intl.formatMessage({ defaultMessage: 'The URL looks invalid' })}
          </div>
        )}
      </FormGroup>
    );
  }
}

UploadFileCustomField.propTypes = {
  intl: PropTypes.object.isRequired,
  customField: PropTypes.object.isRequired,
  selectedFiles: PropTypes.array.isRequired,
  file: PropTypes.object,
  forceRequiredError: PropTypes.bool,
  forceUrlError: PropTypes.bool,
  handleCustomFieldChange: PropTypes.func.isRequired,
  title: PropTypes.string,
  copyLinks: PropTypes.func,
  setRef: PropTypes.func,
};

UploadFileCustomField.defaultProps = {
  forceRequiredError: false,
  forceUrlError: false,
  file: null,
  title: null,
  copyLinks: null,
  setRef: () => {},
};

export default injectIntl(UploadFileCustomField);
